import React ,{ useEffect ,useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import {useParams, useNavigate, Link } from "react-router-dom";

import Access from "../components/access";
import { hasPermission } from "../utils/permissionHelper";


const AddOwnVeh = () => {
  useAuthRedirect();
    const { id } = useParams();
  const navigate = useNavigate(); 
    const [branches, setBranches] = useState([])
    const [vehicleType, setVehicleType] = useState([])
    const [equip, setEquip] = useState([])
  const userName = localStorage.getItem("username"); 
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
 const [formData ,setFormData] = useState({
  vehicle_type:  "" ,vehicle_code:  "" ,vehicle_invoice:  "" ,vehicle_name:  "" ,vehicle_number:  "" ,vehicle_basis:  "" ,vehicle_purfrom:  "" ,vehicle_branch:  "" ,vehicle_make:  "" ,chassis_num:  "" ,Hypothecation:  "" ,model:  "" ,vehicle_regdate:  "" ,vehicle_regno:  "" ,engine_SlNo:  "" ,equip_sino:  "" ,purchese_amt:  "" ,purchase_date:  "" ,insurance_date:  "" ,renewal_date:  "" ,insurance_number:  "" ,premium_your:  "" ,insurance_amt:  "" ,Fc_date:  "" ,Fc_renewaldate:  "" ,hyp_exp_date:  "" ,rc_number:  "" ,vehicle_description:  "" ,roadtax_from:  "" ,roadtax_to:  "" ,fld_equipment:  "" ,insurance_company:  "" ,permit_date:  "" ,permit_expirydate:  "" ,remarks:  "" ,insertDate:  "" ,fld_vehiclecondition:  "" ,fld_utilisation: ""
 
   });

   const canAdd = hasPermission("Own Vehicle Registration", "entry");

   const showLoader = (message = "Loading...") => {
  Swal.fire({
    title: "Please Wait",
    html: `<div style="width: 100%; background: #ddd; border-radius: 5px; overflow: hidden;">
             <div style="height: 10px; width: 100%; background: linear-gradient(90deg, #007bff, #00d4ff); animation: loadBar 2s infinite;"></div>
           </div>
           <p style="margin-top: 10px;">${message}</p>`,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      const style = document.createElement('style');
      style.innerHTML = `
        @keyframes loadBar {
          0% {transform: translateX(-100%)}
          100% {transform: translateX(100%)}
        }
      `;
      document.head.appendChild(style);
    }
  });
};



 useEffect(() => {
  const fetchVehicleType = async () => {
    try {
      showLoader("Loading vehicle info...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_edit_veh_mas_api/${id}`);
      setFormData((prevFormData) => ({
        ...prevFormData,
        vehicle_code: response.data.fld_vehiclecode,
        vehicle_name: response.data.fld_vehiclename,
        insertDate: response.data.insertDate,
      }));
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching record:", error);
      Swal.fire("Error", "Failed to fetch vehicle details.", "error");
    }
  };
  fetchVehicleType();
}, [id]);


useEffect(() => {
  const fetchBranches = async () => {
    try {
      showLoader("Loading branches...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_branches`);
      setBranches(response.data.branches || []);
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching locations:", error);
      Swal.fire("Error", "Unable to load branches.", "error");
    }
  };
  fetchBranches();
}, []);



useEffect(() => {
  const fetchVtype = async () => {
    try {
      showLoader("Loading vehicle types...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_vType`);
      setVehicleType(response.data.vType || []);
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching get_vType:", error);
      Swal.fire("Error", "Failed to fetch vehicle types.", "error");
    }
  };
  fetchVtype();
}, []);

useEffect(() => {
  const fetchEquip = async () => {
    try {
      showLoader("Loading equipment...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_vEquip`);
      setEquip(response.data.vEquip || []);
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching get_vEquip:", error);
      Swal.fire("Error", "Failed to fetch equipment data.", "error");
    }
  };
  fetchEquip();
}, []);


  const handleChange = (e) => {
    const { name ,value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  const payload = {    
    fld_date: formData.fld_date,
    branch_code: formData.branch_code, LogId: userName, vehicle_type: formData.vehicle_type, vehicle_code: formData.vehicle_code, vehicle_invoice: formData.vehicle_code, vehicle_name: formData.vehicle_name, 
vehicle_number: formData.vehicle_number, vehicle_basis: formData.vehicle_basis, vehicle_purfrom: formData.vehicle_purfrom, vehicle_branch: formData.vehicle_branch, vehicle_make: formData.vehicle_make, chassis_num: formData.chassis_num, Hypothecation: formData.Hypothecation, model: formData.model, 
vehicle_regdate: formData.vehicle_regdate, vehicle_regno: formData.vehicle_regno, engine_SlNo: formData.engine_SlNo, equip_sino: formData.equip_sino, purchese_amt: formData.purchese_amt, purchase_date: formData.purchase_date, insurance_date: formData.insurance_date, renewal_date: formData.renewal_date, 
insurance_number: formData.insurance_number, premium_your: formData.premium_your, insurance_amt: formData.insurance_amt, Fc_date: formData.Fc_date, Fc_renewaldate: formData.Fc_renewaldate, hyp_exp_date: formData.hyp_exp_date, rc_number: formData.rc_number, vehicle_description: formData.vehicle_description,
roadtax_from: formData.roadtax_from, roadtax_to: formData.roadtax_to, fld_equipment: formData.fld_equipment, insurance_company: formData.insurance_company, permit_date: formData.permit_date, permit_expirydate: formData.permit_expirydate, remarks: formData.remarks, insert_time: formData.insert_time, 
fld_vehiclecondition: formData.fld_vehiclecondition, fld_utilisation: formData.fld_utilisation
  };
  
// console.log("Submitting Payload:" ,payload);

try {
    
            Swal.fire({
                       title: "Submitting...",
                       text: "Please wait while we process your request.",
                       allowOutsideClick: false,
                       didOpen: () => {
                           Swal.showLoading();
                       },
                   })
                   
  const response = await axios.post(
    `https://rfs2.infraconsoft.net.in/api/add_own_veh_reg/${selectedBranch}/${userName}`,
    payload
  );

  console.log(response);
  
  Swal.fire({
    title: "Success!",
    text: "Inserted successfully.",
    icon: "success",
    width: "500px",
    height: "40vh",
    draggable: true,
}).then(() => {
    navigate("/vehicle_namemaster");
});

} catch (error) {
  console.error("Error submitting form:");
  alert("Submission failed. Please try again.");
}
};


  if (!canAdd) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                        <h2 className="add-txt">Add New Own Vehicle</h2>
                      <Link to='/vehicle_namemaster'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                      </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input
                  type="text"
                  name="vehicle_code"
                  value={formData.vehicle_code}
                  onChange={handleChange}
                  required readonly
                />
              </div>
              <div className="form-group">
                <label>Entry Date:</label>
                <input
                  type="date"
                  name="insertDate"
                  value={formData.insertDate}
                  onChange={handleChange}
                  required readonly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name:</label>
                <input
                  type="text"
                  name="vehicle_name"
                  value={formData.vehicle_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Branch:</label>
                <select name="branch_code" value={formData.branch_code} onChange={handleChange}>
                <option value="">- Select -</option>
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div> 
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Invoice Number :</label>
                <input
                  type="text"
                  name="vehicle_invoice"
                  value={formData.vehicle_invoice}
                  onChange={handleChange}
                   
                />
              </div>    
              <div className="form-group"></div>           
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Make:</label>
                <input
                  type="text"
                  name="vehicle_make"
                  value={formData.vehicle_make}
                  onChange={handleChange}
                   
                />
              </div>    
              <div className="form-group">
                <label>Vehicle Model:</label>
                <input
                  type="text"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                   
                />
                
              </div>      
            </div>
            {/* <h3> Contact Info</h3> */}
            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Type:</label>
                <select name="vehicle_type" value={formData.vehicle_type} onChange={handleChange}>
                    <option value="">- Select -</option>
                  {vehicleType.map((item, index) => (
                    <option key={index} value={item.fld_vehiclename}>
                      {item.fld_vehiclename}
                    </option>
                  ))}
                </select>
                </div>

              <div className="form-group">
                <label>Vehicle Basis:</label>
                <select  name="vehicle_basis"  value={formData.vehicle_basis}   className="branch-select" onChange={handleChange} required >
                <option value="">--- Select ---</option>
                    <option value="Hour">Hour</option>
                    <option value="Km">Km</option>
            </select>
                  </div>
            </div>
             
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Number:</label>
                <input
                  type="text"
                  name="vehicle_number"
                  value={formData.vehicle_number}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Engine SL.No:</label>
                <input
                  type="text"
                  name="engine_SlNo"
                  value={formData.engine_SlNo}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Chassis Number:</label>
                <input
                  type="text"
                  name="chassis_num"
                  value={formData.chassis_num}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Equipment Sl.No:</label>
                <input
                  type="text"
                  name="equip_sino"
                  value={formData.equip_sino}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Reg date:</label>
                <input
                  type="date"
                  name="vehicle_regdate"
                  value={formData.vehicle_regdate}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Vehicle Reg. Number:</label>
                <input
                  type="text"
                  name="vehicle_regno"
                  value={formData.vehicle_regno}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Purchased date:</label>
                <input
                  type="date"
                  name="purchase_date"
                  value={formData.purchase_date}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Purchased From:</label>
                <input
                  type="text"
                  name="vehicle_purfrom"
                  value={formData.vehicle_purfrom}
                  onChange={handleChange}                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Hypothecation with:</label>
                <input
                  type="text"
                  name="Hypothecation"
                  value={formData.Hypothecation}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input
                  type="text"
                  name="purchese_amt"
                  value={formData.purchese_amt}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Insurance date:</label>
                <input
                  type="date"
                  name="insurance_date"
                  value={formData.insurance_date}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Ins. Renewal date:</label>
                <input
                  type="date"
                  name="renewal_date"
                  value={formData.renewal_date}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Insurance Number:</label>
                <input
                  type="text"
                  name="insurance_number"
                  value={formData.insurance_number}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Insured amount:</label>
                <input
                  type="text"
                  name="insurance_amt"
                  value={formData.insurance_amt}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Ins. Premium Per Year:</label>
                <input
                  type="text"
                  name="premium_your"
                  value={formData.premium_your}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Insurance company:</label>
                <input
                  type="text"
                  name="insurance_company"
                  value={formData.insurance_company}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>FC Date:</label>
                <input
                  type="date"
                  name="Fc_date"
                  value={formData.Fc_date}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>FC Renewal date:</label>
                <input
                  type="date"
                  name="Fc_renewaldate"
                  value={formData.Fc_renewaldate}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>RC Book Number:</label>
                <input
                  type="text"
                  name="rc_number"
                  value={formData.rc_number}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Hyp. Expiry date:</label>
                <input
                  type="date"
                  name="hyp_exp_date"
                  value={formData.hyp_exp_date}
                  onChange={handleChange}
                   
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Permit date:</label>
                <input
                  type="date"
                  name="permit_date"
                  value={formData.permit_date}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Permit Expire date:</label>
                <input
                  type="date"
                  name="permit_expirydate"
                  value={formData.permit_expirydate}
                  onChange={handleChange}
                   
                />
             </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Road Tax From Date:</label>
                <input
                  type="date"
                  name="roadtax_from"
                  value={formData.roadtax_from}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Road Tax To Date:</label>
                <input
                  type="date"
                  name="roadtax_to"
                  value={formData.roadtax_to}
                  onChange={handleChange}
                   
                />
             </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle description:</label>
                <input
                  type="text"
                  name="vehicle_description"
                  value={formData.vehicle_description}
                  onChange={handleChange}
                   
                />
              </div>
              <div className="form-group">
                <label>Utilisation:</label>
                <select  name="fld_utilisation"  value={formData.fld_utilisation}   className="branch-select" onChange={handleChange} >
                <option value="">- Select -</option>
                <option value="Excellent">Excellent</option>
                <option value="Good">Good</option>
                <option value="Fair">Fair</option>
                <option value="Poor">Poor</option>
            </select>
             </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Equipment:</label>
                <select name="fld_equipment" value={formData.fld_equipment} onChange={handleChange}>
                <option value="">- Select -</option>
                  {equip.map((item, index) => (
                    <option key={index} value={item.fld_type}>
                      {item.fld_type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Remarks</label>
                <input
                  type="text"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Condition:</label>
                <select  name="fld_vehiclecondition"  value={formData.fld_vehiclecondition}  className="branch-select" onChange={handleChange} >
                <option value="">--Select--</option>
                <option value="EWC-Excellent Working Condition">EWC</option>
                <option value="GWC-Good Working Condition">GWC</option>
                <option value="RMnR-Requiring Minor Repaired Parts">RMnR</option>
                <option value="RMrR-Requiring Major Repaired Parts">RMrR</option>
                <option value="Uc-Uncondition vehicle">Uncondition</option>
            </select>
              </div>
              <div className="form-group"></div>
            </div>
           
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddOwnVeh;
